.overlay {
  z-index: 1000;
}
